import RestrictedUserRoute from "discourse/routes/restricted-user";

export default class PreferencesNotifications extends RestrictedUserRoute {}
